import { useEffect, useState } from 'react';
import { toFixedDefaultValue } from '../constants';

const initialState = {
  getProfit: '0',
  getLoss: '0',
};

export const useCalculatingBet = (instrument, realTimePrice, reqMargin) => {
  const { market } = instrument;

  const [state, setState] = useState(initialState);

  const profitPrice = market.protection.profitValue;
  const lossPrice = market.protection.lossValue;
  const price =
    market.billType === 'sell' ? realTimePrice.ask : realTimePrice.bid;

  useEffect(() => {
    if (!reqMargin) {
      setState(initialState);
    } else {
      setState({
        getProfit: Math.abs(
          profitPrice * market.amountVolume - price * market.amountVolume
        ).toFixed(toFixedDefaultValue),
        getLoss: Math.abs(
          lossPrice * market.amountVolume - price * market.amountVolume
        ).toFixed(toFixedDefaultValue),
      });
    }
  }, [price]);

  return state;
};
